import { Entidad } from "../Entidad";
import { IEscolaridad } from "../entidad/Escolaridad";
import { _DICC_ASIGNACION_ESCOLARIDAD_GRADOS } from "../modulo/Escolaridad";
import { _DICC_ASIGNACION_ESCUELA_ESCOLARIDADES } from "../modulo/Escuela";
import { _DICC_GRUPO } from "../modulo/Grupo";
import { DataModuloMain } from "../ModuloMain";
import { MGrado } from "./MGrado";
import { MGrupo } from "./MGrupo";
import { ModelAdapter } from "./ModelAdapter";

export class MEscolaridad extends ModelAdapter<IEscolaridad> implements IEscolaridad {
    readonly Id: number;
    readonly Nombre: string;
    readonly IdEscuela: number;
    readonly Modificacion: string;
    readonly NivelSAT: "Preescolar" | "Primaria" | "Secundaria" | "Profesional técnico" | "Bachillerato o su equivalente";
    readonly AutRVOE: string;
    readonly EnUso: boolean;

    // =================================================
    // PROPIEDADES ADICIONALES
    // =================================================
    NombreEscuela: string;

    constructor(data: IEscolaridad) {
        super(data);
        this.NombreEscuela = DataModuloMain._GetDataValueFieldByName("Escuela", this.IdEscuela, "Nombre") || "";
    }


    public getGradosDeEscolaridad(): Map<number, MGrado> {
        return _DICC_ASIGNACION_ESCOLARIDAD_GRADOS.get(this.Id) || new Map;
    }

    public getGruposEnEscolaridad(): Array<MGrupo> {
        return Array.from(_DICC_GRUPO.values())
            .filter(d => (d.IdEscolaridad == this.Id));
    }

    public getAlumnosEnEscolaridad(): Array<Entidad.IAlumno> {
        return DataModuloMain._GetReqDataArrayByName("Alumno")
            .filter(d => (d.IdEscolaridad == this.Id));
    }
}